import { render, staticRenderFns } from "./ResultsPDFConfigModal.vue?vue&type=template&id=31d125ea"
import script from "./ResultsPDFConfigModal.vue?vue&type=script&lang=js"
export * from "./ResultsPDFConfigModal.vue?vue&type=script&lang=js"
import style0 from "./ResultsPDFConfigModal.vue?vue&type=style&index=0&id=31d125ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports